import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import {
  ZeeFontBold,
  ZeeFontMedium,
  getInitialLoadIcons
} from 'src/styles/font';
import { flex } from 'src/styles/utils';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';

export const Container = styled.div`
  width: 500px;
  ${flex('row', 'space-between', 'center')};
  border-radius: 10px;
  background: ${colors.white};
  cursor: pointer;
  color: ${colors.AccentDarkGrayColor};
  padding: 16px 16px;
  position: absolute;
  z-index: 20;
  top: 44px;
  left: -360px;
  //notch
  &:after {
    content: '';
    width: 20px;
    height: 20px;
    transform: rotate(-45deg);
    background: ${colors.white};
    position: absolute;
    z-index: -1;
    top: -6px;
    left: 73%;
  }
`;

export const TextContainer = styled.div`
  ${flex('column', '', 'flex-start')};
  gap: 10px;
  text-align: left;
`;
export const Header = styled.div`
  ${ZeeFontBold(18, 26)};
`;
export const Title = styled.div`
  ${ZeeFontMedium(16, 24)};
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
`;

export const CrossButton = styled.div`
  ${getInitialLoadIcons(InitialLoadIconsSet.CLOSE)};
  &:before {
    position: absolute;
    font-size: 30px;
    right: 4px;
    top: 15px;
    color: ${colors.AccentInfoPopupDescriptionMobileColor};
  }
`;
